import(/* webpackMode: "eager", webpackExports: ["ResearchCTA"] */ "/vercel/path0/components/cta/ResearchCTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
